export default "__VITE_ASSET__WN4Bdbnr__"